import React,{ useRef, useEffect } from 'react'
import './menudesktop.scss'
import { gsap, Power3 } from 'gsap';
import { Link } from 'gatsby';
import scrollTo from 'gatsby-plugin-smoothscroll';

const Menudesktop = () => {

    const home = useRef(null);
    const technologies = useRef(null);
    const projects = useRef(null);
    const contact = useRef(null);

    useEffect(() => {
        gsap.to([home.current, technologies.current, projects.current, contact.current],
            {
                duration: 2,
                opacity: 1,
                ease: Power3.easeIn,
                stagger:0.2
            });
    }, []);

    return (
        <ul className="menu-desktop">
            <Link to='/' ref={home} className="menu-desktop__item no-select" tabIndex="2" > Home</Link>
            <li ref={technologies} className="menu-desktop__item">
                <a role="button" tabIndex="3" className="no-select" onClick={() => scrollTo('#technologies')}>Technologies</a>
            </li>
            <li ref={projects} className="menu-desktop__item">
                <a role="button" tabIndex="4" className="no-select"  onClick={() => scrollTo('#projects')} >Projects</a>
            </li>
            <li ref={contact} className="menu-desktop__item">
            <a role="button" tabIndex="5" className="no-select"  onClick={() => scrollTo('#contact')} >Contact</a>
            </li>
        </ul>
    )
}

export default Menudesktop
